import type {
  ExtraAiFeatures,
  ServerConfig,
  User,
  UserPermission
} from 'shared-types';

interface Params {
  requiredAiExtraServerConfig?: ExtraAiFeatures;
  requireAiToolsPermission?: boolean;
  requiredUserPermission?: UserPermission;
  serverConfig: Pick<ServerConfig, 'aiConfig' | 'aiEnabled' | ExtraAiFeatures>;
  user: Pick<User, 'permissions' | 'roles'>;
}

const isAiConfigAvailableForUser = ({
  requiredAiExtraServerConfig,
  requireAiToolsPermission = true,
  requiredUserPermission,
  serverConfig,
  user
}: Params) => {
  const { aiConfig, aiEnabled } = serverConfig;

  // validate general ai config
  if (!aiEnabled) return false;

  // validate user exists
  if (!user) return false;

  const isSuperadmin = user.roles.includes('superadmin');

  // validate user access
  if (
    requireAiToolsPermission &&
    !(
      isSuperadmin ||
      aiConfig?.allowAllAdmins ||
      user.permissions?.includes('use-ai-tools')
    )
  ) {
    return false;
  }

  // if relevant: validate ai extra feature
  if (
    requiredAiExtraServerConfig &&
    !serverConfig[requiredAiExtraServerConfig]
  ) {
    return false;
  }

  // if relevant: validate required permission
  if (
    requiredUserPermission &&
    !isSuperadmin &&
    !user.permissions?.includes(requiredUserPermission)
  ) {
    return false;
  }

  return true;
};

export default isAiConfigAvailableForUser;
